import { render } from "./ResumeReformatter.vue?vue&type=template&id=622eefca&scoped=true"
import script from "./ResumeReformatter.vue?vue&type=script&lang=js"
export * from "./ResumeReformatter.vue?vue&type=script&lang=js"

import "./ResumeReformatter.vue?vue&type=style&index=0&id=622eefca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622eefca"]])

export default __exports__